var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTemplate = function SvgTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.382 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.778-6.306 14.084-14.083 14.084C6.6 33.453.295 27.143.295 19.365.295 11.586 6.6 5.28 14.382 5.28Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.353 15.103a.611.611 0 0 0-.703-.703l-2.07.345a14.46 14.46 0 0 1 2.428 2.432l.345-2.074Zm-.79 3.496a13.128 13.128 0 0 0-1.555-1.87 13.13 13.13 0 0 0-1.85-1.542l-2.273 2.43a.546.546 0 0 1-.015.015l-1.694 1.81a2.218 2.218 0 0 0-.297 2.631l3.404-3.403a.6.6 0 1 1 .848.848l-3.39 3.39a2.218 2.218 0 0 0 2.57-.331l1.808-1.692a.626.626 0 0 1 .02-.02l2.424-2.266Zm-1.334 2.89 2.182-2.04a2.08 2.08 0 0 0 .63-1.178l.496-2.97a1.811 1.811 0 0 0-2.084-2.085l-2.972.495a2.08 2.08 0 0 0-1.176.63l-2.041 2.183-1.376-.459a1.205 1.205 0 0 0-1.16.223l-1.73 1.464a1.206 1.206 0 0 0 .361 2.052l1.102.406a3.42 3.42 0 0 0 .55 2.73L8.53 24.424a.6.6 0 1 0 .848.848l1.49-1.49a3.421 3.421 0 0 0 2.675.512l.406 1.1a1.206 1.206 0 0 0 2.052.362l1.464-1.73c.271-.321.356-.76.223-1.16l-.459-1.376Zm-.964.902-1.135 1.062a3.43 3.43 0 0 1-.479.375l.424 1.15.001.003.003.001m.004 0 .002-.002 1.464-1.73a.006.006 0 0 0 0-.005l-.284-.854m-6.34-3.29a3.43 3.43 0 0 1 .375-.478l1.062-1.135-.854-.285-.005.001-1.73 1.464-.003.002",
    fill: "#0086C9"
  })));
};

export default SvgTemplate;